import { Euler, Matrix4, Quaternion, Vector3 } from 'three';
import { CUBE_SIZE } from '../../../3d/state/cuboid-location-state-3d';
import {
  buildCuboidTransformState,
  CuboidTransformState,
} from '../../../3d/test-helpers/builders/build-cuboid-location-3d';
import { buildCuboidPoints3D } from '../../../3d/utils/cuboid-utils';
import { roundVector } from '../../../shared/misc-utilities/point-utils';
import { Point3D } from '../../../team-apis/otterdam/answers/shape-typings';

export function buildCuboidPoints(state?: Partial<CuboidTransformState>) {
  const { position, rotation, scale } = buildCuboidTransformState({}, state);

  const transformMatrix = new Matrix4().compose(
    new Vector3().fromArray(position),
    new Quaternion().setFromEuler(new Euler(...rotation)),
    new Vector3().fromArray(scale),
  );

  const points = getCuboidDefaultPoints().map((point) =>
    roundVector(new Vector3().fromArray(point).applyMatrix4(transformMatrix)),
  );

  return points;
}

function getCuboidDefaultPoints(): Point3D[] {
  return buildCuboidPoints3D({
    position: [0, 0, 0],
    scale: [CUBE_SIZE, CUBE_SIZE, CUBE_SIZE],
  });
}
